export const GET_BANNER_LIST_REQUEST = "GET_BANNER_LIST_REQUEST";
export const GET_BANNER_LIST_SUCCESS = "GET_BANNER_LIST_SUCCESS";
